/*
 * Copyright (c) 2019. Unconventional Software Corporation
 */

import {StageSpriteUtils} from "../../shared/StageSpriteUtils";

export class Announcement {

  static readonly STATUS_UNPUBLISHED: number = 0;
  static readonly STATUS_PUBLISHED: number = 1;

  static readonly ICONS: {[key: number]: string} = {
    0: 'chatbubbles',
    1: 'md-pricetag'
  };

  public timestampPosted: number;
  public formattedTime: string;

  public icon: string;

  constructor(public id: string,
              public title: string,
              public description: string,
              public author: string,
              public announcementType: number,
              public image: string,
              public url: string,
              public status: number = Announcement.STATUS_UNPUBLISHED) {

  }

  static fromAngularFireSnapshots(snapshots: any) : Announcement[] {
    return snapshots.map(snap => Announcement._fromSnapshot(snap.key, snap.payload.val()));
  }

  static fromSnapshot(id: string, data: any): Announcement {
    if (!data) {
      return null;
    }
    return this._fromSnapshot(id, data);
  }

  private static _fromSnapshot(key: string, {author, datePosted, description, announcementType, image, title, timestampPosted, url, status, iconOverride}) {
    let announcement = new Announcement(key, title, description, author, announcementType || 0, image, url, status);
    if (datePosted) {
      announcement.formattedTime = StageSpriteUtils.formatDateTimeIgnoreTimeZone(datePosted);
    }
    announcement.timestampPosted = timestampPosted;

    if (iconOverride) {
      announcement.icon = iconOverride;
    } else {
      announcement.icon = Announcement.ICONS[announcementType];
    }

    return announcement;
  }
}



// WEBPACK FOOTER //
// ./src/providers/announcements/Announcement.ts